module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "payment-detail"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px",
      "display": "flex",
      "flex-direction": "row",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("公司列表")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row"
    }
  }, [_c('div', {
    staticClass: "add-btn",
    on: {
      "click": _vm.addCompany
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增公司")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10px",
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "size": "middle",
      "placeholder": "输入公司名称搜索"
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        _vm.searchName = $event
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.searchComp($event)
      }
    }
  }, [(_vm.nameList.length > 0) ? _c('el-button', {
    staticStyle: {
      "color": "#fff",
      "background": "#409eff",
      "border": "1px solid #409eff"
    },
    attrs: {
      "disabled": _vm.showNameIdx === _vm.nameList.length
    },
    on: {
      "click": _vm.nextName
    },
    slot: "append"
  }, [_vm._v("下一个")]) : _vm._e()], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "primary",
      "size": "middle"
    },
    on: {
      "click": _vm.searchComp
    }
  }, [_vm._v("搜索")])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "company-list"
    }
  }, [(_vm.isEmptyCompanies) ? _c('div', {
    staticClass: "company-row"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "flex": "1 0 100%"
    }
  }, [_vm._v("暂无公司信息，请先新增公司")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.$store.state.auth.companies), function(company, index) {
    return (!_vm.isEmptyCompanies) ? _c('div', {
      ref: ("div-company-" + (company.id)),
      refInFor: true,
      staticClass: "company-row",
      class: {
        selected: _vm.selectedIndex === index,
        found: company.id == _vm.showNameId
      },
      on: {
        "click": function($event) {
          _vm.select(index)
        }
      }
    }, [_c('div', {
      staticClass: "comdetail_l"
    }, [_c('span', {
      staticClass: "company-name"
    }, [_vm._v(_vm._s(company.name))]), _vm._v(" "), _c('span', {
      staticClass: "company-rep"
    }, [_vm._v(_vm._s(company.legalPerson))]), _vm._v(" "), _c('span', {
      staticClass: "company-addr"
    }, [_vm._v(_vm._s(company.address))]), _vm._v(" "), _c('span', {
      staticClass: "insured"
    }, [(company.isInsured) ? _c('span', [_vm._v("参保人信息")]) : _vm._e()]), _vm._v(" "), _c('span', {
      staticClass: "default"
    }, [(company.isDefault) ? _c('span', [_vm._v("默认")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "r",
      staticStyle: {
        "padding-right": "20px"
      }
    }, [(!company.isInsured) ? _c('span', {
      staticClass: "edit-btn",
      on: {
        "click": function($event) {
          _vm.edit(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-edit"
    }), _vm._v("修改")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "delete-btn",
      on: {
        "click": function($event) {
          _vm.deleteCompany(index)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete"
    }), _vm._v("删除")])])]) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-0bc28e77!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanySelection.vue
// module id = 1008
// module chunks = 40